import { MapPin } from "lucide-react";

const STORAGE_IMG = "https://images.pexels.com/photos/5759037/pexels-photo-5759037.jpeg";

const primaryCities = ["Louisville", "Lexington", "Frankfort", "Bowling Green", "Owensboro", "Covington", "Cincinnati", "Indianapolis"];
const states = [
  { code: "KY", name: "Kentucky" },
  { code: "IN", name: "Indiana" },
  { code: "OH", name: "Ohio" },
  { code: "WV", name: "West Virginia" },
];

export default function ServiceAreas() {
  return (
    <section id="coverage" className="py-24 lg:py-32 bg-[#EBE8DD]" data-testid="coverage-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2 relative">
          <img src={STORAGE_IMG} alt="Climate-controlled storage facility" className="w-full aspect-square object-cover" />
          <div className="absolute -bottom-6 -right-6 bg-[#5BB239] text-white p-6 max-w-[220px]">
            <div className="font-display font-black text-3xl tracking-tight">4 States</div>
            <div className="font-mono-label text-[10px] mt-1">KY · IN · OH · WV</div>
          </div>
        </div>
        <div className="lg:col-span-3">
          <div className="overline">Where We Roll</div>
          <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            Based in KY.<br />Serving four states.
          </h2>
          <p className="mt-6 text-[#5C635F] leading-relaxed max-w-lg">
            Your local moving pros for Kentucky and our neighbors — Indiana, Ohio, and
            West Virginia. Whether it's across town or across the river, we've got you.
          </p>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3">
            {states.map((s) => (
              <div key={s.code} className="bg-[#223932] text-white p-4">
                <div className="font-display font-black text-4xl tracking-tight">{s.code}</div>
                <div className="font-mono-label text-[10px] text-white/60 mt-1">{s.name}</div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <div className="overline mb-4">Key Hubs</div>
            <div className="flex flex-wrap gap-2">
              {primaryCities.map((c) => (
                <span key={c} className="inline-flex items-center gap-1.5 bg-[#F5F3EC] border border-[#DDD8C9] px-3 py-1.5 text-xs font-medium">
                  <MapPin className="w-3 h-3 text-[#5BB239]" /> {c}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
